import React, { useState } from 'react'
import { useAuth } from '../context/AuthContext';
import { useContactInfo } from '../services/Contact';

const Footer = ({ scrollTo }) => {
    const { isTokenValid, logout } = useAuth();
    const { contacts, addContact, updateContact, deleteContact } = useContactInfo();
    const [newInputs, setNewInputs] = useState({ address: '', email: '', phone: '' });

    const renderItems = (type) =>
        contacts.filter(c => c.type === type).map(c => (
            <div key={c.id} className="d-flex align-items-center mb-2">
                {isTokenValid ? (
                    <>
                        <input
                            value={c.value}
                            disabled={true}
                            className="form-control me-2"
                            onChange={e => updateContact(c.id, e.target.value)}
                        />
                        <button className="btn btn-danger btn-sm" onClick={() => deleteContact(c.id)}>✕</button>
                    </>
                ) : (
                    <p className="mb-0"><i className={`fas fa-${type === 'address' ? 'home' : type === 'email' ? 'envelope' : 'phone'} me-2`}></i>{c.value}</p>
                )}
            </div>
        ));

    const renderAddInput = (type, placeholder) => (
        <div className="d-flex mt-2">
            <input
                placeholder={placeholder}
                className="form-control me-2"
                value={newInputs[type]}
                onChange={e => setNewInputs({ ...newInputs, [type]: e.target.value })}
            />
            <button
                className="btn btn-success"
                onClick={() => {
                    if (newInputs[type]) {
                        addContact(type, newInputs[type]);
                        setNewInputs({ ...newInputs, [type]: '' });
                    }
                }}
            >
                +
            </button>
        </div>
    );

    return (
        <section id="footer" className="py-0">
            <footer className="text-center text-lg-start text-white" style={{ background: '#4D4D4D' }}>
                <section className="d-flex justify-content-center justify-content-lg-between p-4 border-bottom">

                    <div className="me-5 d-none d-lg-block">
                        <span>Contáctanos a través de nuestras redes sociales:</span>
                    </div>

                    <div>
                        <a href="https://www.facebook.com/sanitarios.mobiles?locale=es_LA" target='_blank' className="me-4 text-reset">
                            <i className="fab fa-facebook-f"></i>
                        </a>
                        <a href="https://www.instagram.com/sani_star_mobile/" target='_blank' className="me-4 text-reset">
                            <i className="fab fa-instagram"></i>
                        </a>
                    </div>

                </section>

                <section className="">
                    <div className="container text-center text-md-start mt-5">
                        <div className="row mt-3">
                            <div className="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
                                <h6 className="text-uppercase fw-bold mb-4">
                                    <i className="fas fa-restroom me-3"></i>Sani Star Mobile
                                </h6>
                                <p style={{ textAlign: 'justify' }}>
                                    Confía en Sani Star Mobile para mantener tus espacios limpios y funcionales. ¡Contáctanos hoy y descubre la diferencia que hace trabajar con los mejores!
                                </p>
                            </div>

                            <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
                                <h6 className="text-uppercase fw-bold mb-4">
                                    Secciones
                                </h6>
                                <p>
                                    <a onClick={() => scrollTo('gallery')} className="text-reset" style={{ cursor: 'pointer' }}>Galería</a>
                                </p>
                                <p>
                                    <a onClick={() => scrollTo('about')} className="text-reset" style={{ cursor: 'pointer' }}>Acerca de nosotros</a>
                                </p>
                                <p>
                                    <a onClick={() => scrollTo('services')} className="text-reset" style={{ cursor: 'pointer' }}>Nuestros servicios</a>
                                </p>
                                <p>
                                    <a onClick={() => scrollTo('contact')} className="text-reset" style={{ cursor: 'pointer' }}>Contáctanos</a>
                                </p>
                                <p>
                                    {
                                        !isTokenValid ? (
                                            <a href='/admin-login' className="text-reset" style={{ cursor: 'pointer' }}>Editar esta página</a>
                                        ) : (
                                            <a onClick={logout} className="text-reset" style={{ cursor: 'pointer' }}>Cerrar sesión</a>
                                        )
                                    }
                                </p>
                            </div>

                            <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
                                <h6 className="text-uppercase fw-bold mb-4">Contacto</h6>
                                {renderItems('address')}
                                {isTokenValid && renderAddInput('address', 'Nueva dirección')}
                                {renderItems('email')}
                                {isTokenValid && renderAddInput('email', 'Nuevo correo')}
                                {renderItems('phone')}
                                {isTokenValid && renderAddInput('phone', 'Nuevo teléfono')}
                            </div>
                        </div>
                    </div>
                </section>

                <div className="text-center p-4 text-white" style={{ backgroundColor: '#353535' }}>
                    © {new Date().getFullYear()} Copyright:
                    <a className="text-reset fw-bold" href="#"> Sani Star Mobile</a>
                </div>
            </footer >
        </section >
    );
};

export default Footer;